export const TOKEN = 'token'
export const USER_ID = 'user_id'
export const ARTICLE_TO_SEL = 'article_to_sel'
export const SELECTION_ID = 'selection_id'